import { InjectionToken } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

const BsDefaultConfig: BsDatepickerConfig = new BsDatepickerConfig;

BsDefaultConfig.adaptivePosition = true;
BsDefaultConfig.dateInputFormat = 'DD.MM.YYYY';
BsDefaultConfig.isAnimated = true;
BsDefaultConfig.customTodayClass = 'today'
BsDefaultConfig.showWeekNumbers = true;

export default BsDefaultConfig